<template>
  <div>
    <ul class="top_ul">
      <li v-for="(item,index) in numList" :key="index">
        <div><img :src="item.icon">
          <span>{{ item.name }}</span>
          <h3>{{ item.num }}</h3>
        </div>
        <img :src="item.img">
      </li>
    </ul>
    <div class="center">
      <div class="echarts" id="echarts-box">
        <div class="title">产业新闻<span>更多&nbsp;></span></div>
        <div class="echarts-main" ref="main"></div>
      </div>
      <div class="data-list">
        <div class="title">{{ articleObj.columnName }}<span @click="jumpToDetail()">更多&nbsp;></span></div>
        <ul>
          <li v-for="(item,index) in articleObj.articleList" :key="index" @click="jumpArticleDetail(item)">
            <img src="../assets/imgs/index-first@2x.png" v-if="index == 0" />
            <img src="../assets/imgs/index-second@2x.png" v-else-if="index == 1" />
            <img src="../assets/imgs/index-third@2x.png" v-else-if="index == 2" />
            <span v-else>{{ index + 1 }}</span>
            <p>{{item.title}}</p>
          </li>
        </ul>
      </div>
    </div>
    <ul class="bottom">
      <li>
        <span class="title">产业新闻</span>
        <div class="echart1" ref="echart1"></div>
      </li>
      <li>
        <span class="title">产业新闻</span>
        <div class="echart2" ref="echart2"></div>
      </li>
      <li>
        <span class="title">产业新闻</span>
        <div class="echart3" ref="echart3" id="echart3"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { apiGet } from "../assets/http";
// import "@/utils/echarts-wordcloud.min.js";
import Js2WordCloud from "js2wordcloud";

export default {
  data() {
    return {
      articleObj: {},
      numList: [
        {
          name: "图表数据",
          icon: require("../assets/imgs/product_icon1@2x.png"),
          img: require("../assets/imgs/product_img1@2x.png"),
          num: "15,031,913",
        },
        {
          name: "招股说明书",
          icon: require("../assets/imgs/product_icon2@2x.png"),
          img: require("../assets/imgs/product_img2@2x.png"),
          num: "368,372",
        },
        {
          name: "研究报告",
          icon: require("../assets/imgs/product_icon3@2x.png"),
          img: require("../assets/imgs/product_img3@2x.png"),
          num: "445,285",
        },
        {
          name: "行业新闻",
          icon: require("../assets/imgs/product_icon4@2x.png"),
          img: require("../assets/imgs/product_img4@2x.png"),
          num: "1,092,125",
        },
      ],
    };
  },
  created() {
    this.getArticleList();
  },
  mounted() {
    this.getInit();
    this.getInit1();
    this.getInit2();
    this.getInit3();
  },
  methods: {
    getArticleList() {
      apiGet("/business/web/getProductOverview", {}).then((res) => {
        this.articleObj = res.data;
      });
    },
    jumpToDetail() {
      this.$emit("changeProductFlag", false);
    },
    jumpArticleDetail(item) {
      if (item.link != null) {
        window.open(item.link, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/article",
          name: "article",
          query: { articleId: item.articleId },
        });
        console.log(routeUrl.href);
        window.open(routeUrl.href, "_blank");
      }
    },
    // 柱状图堆叠
    getInit() {
      var myChart = this.$echarts.init(this.$refs.main);
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["图表数据", "列表数据"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: { show: false },
            axisTick: { show: false },
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Line 1",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#1279FF",
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(101,151,255,0.47)",
                },
                {
                  offset: 1,
                  color: "rgba(101,151,254,0.02)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [140, 232, 101, 264, 90, 340, 250],
          },
          {
            name: "Line 2",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 2,
              color: "#29CCA9",
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: " rgba(71,208,162,0.27)",
                },
                {
                  offset: 1,
                  color: "rgba(74,208,163,0)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [120, 282, 111, 234, 220, 340, 310],
          },
        ],
      };

      // let xAxisData = [];
      // let data1 = [];
      // let data2 = [];
      // let data3 = [];
      // let data4 = [];
      // for (let i = 0; i < 10; i++) {
      //   xAxisData.push("Class" + i);
      //   data1.push(+(Math.random() * 2).toFixed(2));
      //   data2.push(+(Math.random() * 5).toFixed(2));
      //   data3.push(+(Math.random() + 0.3).toFixed(2));
      //   data4.push(+Math.random().toFixed(2));
      // }
      // var emphasisStyle = {
      //   itemStyle: {
      //     shadowBlur: 10,
      //     shadowColor: "rgba(0,0,0,0.3)",
      //   },
      // };
      // var option = {
      //   legend: {
      //     data: ["bar", "bar2", "bar3", "bar4"],
      //     icon: "circle",
      //     itemWidth: 10,
      //     itemHeight: 10,
      //   },
      //   tooltip: {},
      //   xAxis: {
      //     data: xAxisData,
      //     axisLine: { show: false },
      //     axisTick: { show: false },
      //   },
      //   yAxis: {},
      //   grid: {
      //     bottom: 100,
      //   },
      //   series: [
      //     {
      //       name: "bar",
      //       type: "bar",
      //       stack: "one",
      //       emphasis: emphasisStyle,
      //       itemStyle: {
      //         color: "#4190F6",
      //       },
      //       barWidth: 15,
      //       data: data1,
      //     },
      //     {
      //       name: "bar2",
      //       type: "bar",
      //       stack: "one",
      //       emphasis: emphasisStyle,
      //       itemStyle: {
      //         color: "#88BCFF",
      //       },
      //       barWidth: 15,
      //       data: data2,
      //     },
      //     {
      //       name: "bar3",
      //       type: "bar",
      //       stack: "one",
      //       emphasis: emphasisStyle,
      //       itemStyle: {
      //         color: "#AACFFF",
      //       },
      //       barWidth: 15,
      //       data: data2,
      //     },
      //     {
      //       name: "bar4",
      //       type: "bar",
      //       stack: "one",
      //       emphasis: emphasisStyle,
      //       itemStyle: {
      //         color: "#E0EEFF",
      //         borderRadius: [76, 76, 0, 0],
      //       },
      //       barWidth: 15,
      //       data: data2,
      //     },
      //   ],
      // };
      option && myChart.setOption(option);
    },
    // 环形
    getInit1() {
      var myChart = this.$echarts.init(this.$refs.echart1);
      var option = {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: "报告总数",
          //主标题
          subtext: "92.189",
          //副标题
          textStyle: {
            //主标题样式
            color: "#999999",
            fontSize: 12,
            fontFamily: "Arial",
          },
          subtextStyle: {
            //副标题样式
            fontSize: 16,
            fontWeight: "bold",
            color: "#1A263B",
            lineHeight: 10,
            fontFamily: "Arial",
          },
          left: 80,
          top: 90,
        },

        legend: {
          type: "scroll",
          orient: "vertical",
          right: 20,
          top: "center",
          icon: "circle",
          itemWidth: 10,
          itemHeight: 10,
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            // radius: ["30%", "50%"],
            radius: ["55%", "74%"],
            center: [110, "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            data: [
              { value: 1048, name: "传统行业" },
              { value: 735, name: "先进制造" },
              { value: 580, name: "信息科技" },
              { value: 484, name: "大消费" },
              { value: 300, name: "节能环保" },
              { value: 300, name: "节能环保1" },
              { value: 300, name: "节能环保2" },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 多环形重叠
    getInit2() {
      var myChart = this.$echarts.init(this.$refs.echart2);
      var fxdata = [
        {
          name: "环保服务",
          value: 754,
          color: "#1293FF",
        },
        {
          name: "储能",
          value: 200,
          color: "#FF7E7E",
        },
        {
          name: "再生资源",
          value: 200,
          color: "#FDCA7F",
        },
      ];

      var sumValue = 1000;
      var optionData = getData(fxdata);

      function getData(fxdata) {
        var res = {
          series: [],
          yAxis: [],
        };
        for (let i = 0; i < fxdata.length; i++) {
          res.series.push({
            name: "学历",
            type: "pie",
            clockWise: true,
            color: fxdata[i].color,
            z: 3,
            hoverAnimation: false,
            radius: [68 - i * 17 + "%", 74 - i * 17 + "%"],
            center: [160, 100],
            label: {
              show: false,
              formatter: "{d}%",
              color: "RGB(246,175,101)",
              fontSize: 25,
              position: "inside",
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderRadius: 10,
            },
            data: [
              {
                value: fxdata[i].value,
                name: fxdata[i].name,
              },
              {
                value: sumValue - fxdata[i].value,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                label: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.series.push({
            name: "背景线",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: true,
            hoverAnimation: false,
            // 72 80
            //前内 后外 *后环间距
            radius: [68 - i * 17 + "%", 74 - i * 17 + "%"],
            center: [160, 100],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  color: "#EDF0F4",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.yAxis.push(fxdata[i].name);
        }
        return res;
      }

      var option = {
        title: {
          text: "报告总数",
          //主标题
          subtext: "92.189",
          //副标题
          textStyle: {
            //主标题样式
            color: "#999999",
            fontSize: 12,
            fontFamily: "Arial",
          },
          subtextStyle: {
            //副标题样式
            fontSize: 16,
            fontWeight: "bold",
            color: "#1A263B",
            lineHeight: 10,
          },
          left: "center",
          top: 80,
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: 15,

          icon: "circle",
          itemWidth: 10,
          itemHeight: 10,
          data: ["环保服务", "储能", "再生资源"],
        },

        grid: {
          top: "16%",
          bottom: "54%",
          left: "50%",
          containLabel: false,
        },

        xAxis: [
          {
            show: false,
          },
        ],
        series: optionData.series,
      };
      option && myChart.setOption(option);
    },
    // 词云
    // getInit3() {
    //   var myChart = this.$echarts.init(this.$refs.echart3);
    //   var data = {
    //     value: [
    //       {
    //         word: "unine",
    //         count: 2041,
    //         heat_diff_num: 2040,
    //         name: "unine",
    //         value: 2040,
    //       },
    //       {
    //         word: "生日快乐",
    //         count: 13369,
    //         heat_diff_num: 667.45,
    //         name: "生日快乐",
    //         value: 667.45,
    //       },
    //       {
    //         word: "预告",
    //         count: 464,
    //         heat_diff_num: 76.33333333333333,
    //         name: "预告",
    //         value: 76.33333333333333,
    //       },
    //       {
    //         word: "期待",
    //         count: 463,
    //         heat_diff_num: 65.14285714285714,
    //         name: "期待",
    //         value: 65.14285714285714,
    //       },
    //       {
    //         word: "周边",
    //         count: 450,
    //         heat_diff_num: 55.25,
    //         name: "周边",
    //         value: 55.25,
    //       },
    //       {
    //         word: "可爱",
    //         count: 2280,
    //         heat_diff_num: 33.02985074626866,
    //         name: "可爱",
    //         value: 33.02985074626866,
    //       },
    //       {
    //         word: "吵架",
    //         count: 560,
    //         heat_diff_num: 30.11111111111111,
    //         name: "吵架",
    //         value: 30.11111111111111,
    //       },
    //       {
    //         word: "开心",
    //         count: 871,
    //         heat_diff_num: 30.107142857142858,
    //         name: "开心",
    //         value: 30.107142857142858,
    //       },
    //       {
    //         word: "开心",
    //         count: 871,
    //         heat_diff_num: 30.107142857142858,
    //         name: "开心",
    //         value: 30.107142857142858,
    //       },
    //       {
    //         word: "回来",
    //         count: 608,
    //         heat_diff_num: 29.4,
    //         name: "回来",
    //         value: 29.4,
    //       },
    //       {
    //         word: "衣服",
    //         count: 699,
    //         heat_diff_num: 29.391304347826086,
    //         name: "衣服",
    //         value: 29.391304347826086,
    //       },
    //       {
    //         word: "踢踢",
    //         count: 724,
    //         heat_diff_num: 29.166666666666668,
    //         name: "踢踢",
    //         value: 29.166666666666668,
    //       },
    //       {
    //         word: "快乐",
    //         count: 907,
    //         heat_diff_num: 28.258064516129032,
    //         name: "快乐",
    //         value: 28.258064516129032,
    //       },
    //       {
    //         word: "客服",
    //         count: 733,
    //         heat_diff_num: 26.14814814814815,
    //         name: "客服",
    //         value: 26.14814814814815,
    //       },
    //       {
    //         word: "升华",
    //         count: 569,
    //         heat_diff_num: 26.095238095238095,
    //         name: "升华",
    //         value: 26.095238095238095,
    //       },
    //       {
    //         word: "unine",
    //         count: 2041,
    //         heat_diff_num: 2040,
    //         name: "unine",
    //         value: 2040,
    //       },
    //       {
    //         word: "生日快乐",
    //         count: 13369,
    //         heat_diff_num: 667.45,
    //         name: "生日快乐",
    //         value: 667.45,
    //       },
    //       {
    //         word: "预告",
    //         count: 464,
    //         heat_diff_num: 76.33333333333333,
    //         name: "预告",
    //         value: 76.33333333333333,
    //       },
    //       {
    //         word: "预告",
    //         count: 464,
    //         heat_diff_num: 76.33333333333333,
    //         name: "预告",
    //         value: 76.33333333333333,
    //       },
    //       {
    //         word: "预告",
    //         count: 464,
    //         heat_diff_num: 76.33333333333333,
    //         name: "预告",
    //         value: 76.33333333333333,
    //       },
    //       {
    //         word: "期待",
    //         count: 463,
    //         heat_diff_num: 65.14285714285714,
    //         name: "期待",
    //         value: 65.14285714285714,
    //       },
    //       {
    //         word: "周边",
    //         count: 450,
    //         heat_diff_num: 55.25,
    //         name: "周边",
    //         value: 55.25,
    //       },
    //       {
    //         word: "可爱",
    //         count: 2280,
    //         heat_diff_num: 33.02985074626866,
    //         name: "可爱",
    //         value: 33.02985074626866,
    //       },
    //       {
    //         word: "吵架",
    //         count: 560,
    //         heat_diff_num: 30.11111111111111,
    //         name: "吵架",
    //         value: 30.11111111111111,
    //       },
    //       {
    //         word: "开心",
    //         count: 871,
    //         heat_diff_num: 30.107142857142858,
    //         name: "开心",
    //         value: 30.107142857142858,
    //       },
    //       {
    //         word: "开心",
    //         count: 871,
    //         heat_diff_num: 30.107142857142858,
    //         name: "开心",
    //         value: 30.107142857142858,
    //       },
    //       {
    //         word: "回来",
    //         count: 608,
    //         heat_diff_num: 29.4,
    //         name: "回来",
    //         value: 29.4,
    //       },
    //       {
    //         word: "衣服",
    //         count: 699,
    //         heat_diff_num: 29.391304347826086,
    //         name: "衣服",
    //         value: 29.391304347826086,
    //       },
    //       {
    //         word: "快乐",
    //         count: 907,
    //         heat_diff_num: 28.258064516129032,
    //         name: "快乐",
    //         value: 28.258064516129032,
    //       },
    //       {
    //         word: "客服",
    //         count: 733,
    //         heat_diff_num: 26.14814814814815,
    //         name: "客服",
    //         value: 26.14814814814815,
    //       },
    //       {
    //         word: "升华",
    //         count: 569,
    //         heat_diff_num: 26.095238095238095,
    //         name: "升华",
    //         value: 26.095238095238095,
    //       },
    //       {
    //         word: "生日",
    //         count: 950,
    //         heat_diff_num: 23.358974358974358,
    //         name: "生日",
    //         value: 23.358974358974358,
    //       },
    //       {
    //         word: "卡面",
    //         count: 567,
    //         heat_diff_num: 20.807692307692307,
    //         name: "卡面",
    //         value: 20.807692307692307,
    //       },
    //       {
    //         word: "粉丝",
    //         count: 649,
    //         heat_diff_num: 20.633333333333333,
    //         name: "粉丝",
    //         value: 20.633333333333333,
    //       },
    //       {
    //         word: "时间",
    //         count: 431,
    //         heat_diff_num: 20.55,
    //         name: "时间",
    //         value: 20.55,
    //       },
    //       {
    //         word: "升华",
    //         count: 569,
    //         heat_diff_num: 26.095238095238095,
    //         name: "升华",
    //         value: 26.095238095238095,
    //       },
    //       {
    //         word: "生日",
    //         count: 950,
    //         heat_diff_num: 23.358974358974358,
    //         name: "生日",
    //         value: 23.358974358974358,
    //       },
    //       {
    //         word: "卡面",
    //         count: 567,
    //         heat_diff_num: 20.807692307692307,
    //         name: "卡面",
    //         value: 20.807692307692307,
    //       },
    //       {
    //         word: "粉丝",
    //         count: 649,
    //         heat_diff_num: 20.633333333333333,
    //         name: "粉丝",
    //         value: 20.633333333333333,
    //       },
    //       {
    //         word: "时间",
    //         count: 431,
    //         heat_diff_num: 20.55,
    //         name: "时间",
    //         value: 20.55,
    //       },
    //       {
    //         word: "吵架",
    //         count: 560,
    //         heat_diff_num: 30.11111111111111,
    //         name: "吵架",
    //         value: 30.11111111111111,
    //       },
    //       {
    //         word: "升华",
    //         count: 569,
    //         heat_diff_num: 26.095238095238095,
    //         name: "升华",
    //         value: 26.095238095238095,
    //       },
    //       {
    //         word: "生日",
    //         count: 950,
    //         heat_diff_num: 23.358974358974358,
    //         name: "生日",
    //         value: 23.358974358974358,
    //       },
    //       {
    //         word: "卡面",
    //         count: 567,
    //         heat_diff_num: 20.807692307692307,
    //         name: "卡面",
    //         value: 20.807692307692307,
    //       },
    //       {
    //         word: "粉丝",
    //         count: 649,
    //         heat_diff_num: 20.633333333333333,
    //         name: "粉丝",
    //         value: 20.633333333333333,
    //       },
    //       {
    //         word: "时间",
    //         count: 431,
    //         heat_diff_num: 20.55,
    //         name: "时间",
    //         value: 20.55,
    //       },
    //       {
    //         word: "吵架",
    //         count: 560,
    //         heat_diff_num: 30.11111111111111,
    //         name: "吵架",
    //         value: 30.11111111111111,
    //       },
    //       {
    //         word: "吵架",
    //         count: 560,
    //         heat_diff_num: 30.11111111111111,
    //         name: "吵架",
    //         value: 30.11111111111111,
    //       },
    //       {
    //         word: "开心",
    //         count: 871,
    //         heat_diff_num: 30.107142857142858,
    //         name: "开心",
    //         value: 30.107142857142858,
    //       },
    //       {
    //         word: "回来",
    //         count: 608,
    //         heat_diff_num: 29.4,
    //         name: "回来",
    //         value: 29.4,
    //       },
    //       {
    //         word: "衣服",
    //         count: 699,
    //         heat_diff_num: 29.391304347826086,
    //         name: "衣服",
    //         value: 29.391304347826086,
    //       },
    //       {
    //         word: "踢踢",
    //         count: 724,
    //         heat_diff_num: 29.166666666666668,
    //         name: "踢踢",
    //         value: 29.166666666666668,
    //       },
    //       {
    //         word: "快乐",
    //         count: 907,
    //         heat_diff_num: 28.258064516129032,
    //         name: "快乐",
    //         value: 28.258064516129032,
    //       },
    //       {
    //         word: "客服",
    //         count: 733,
    //         heat_diff_num: 26.14814814814815,
    //         name: "客服",
    //         value: 26.14814814814815,
    //       },
    //       {
    //         word: "粉丝",
    //         count: 649,
    //         heat_diff_num: 20.633333333333333,
    //         name: "粉丝",
    //         value: 20.633333333333333,
    //       },
    //       {
    //         word: "时间",
    //         count: 431,
    //         heat_diff_num: 20.55,
    //         name: "时间",
    //         value: 20.55,
    //       },
    //       {
    //         word: "吵架",
    //         count: 560,
    //         heat_diff_num: 30.11111111111111,
    //         name: "吵架",
    //         value: 30.11111111111111,
    //       },
    //       {
    //         word: "开心",
    //         count: 871,
    //         heat_diff_num: 30.107142857142858,
    //         name: "开心",
    //         value: 30.107142857142858,
    //       },
    //       {
    //         word: "回来",
    //         count: 608,
    //         heat_diff_num: 29.4,
    //         name: "回来",
    //         value: 29.4,
    //       },
    //       {
    //         word: "衣服",
    //         count: 699,
    //         heat_diff_num: 29.391304347826086,
    //         name: "衣服",
    //         value: 29.391304347826086,
    //       },
    //       {
    //         word: "时间",
    //         count: 431,
    //         heat_diff_num: 20.55,
    //         name: "时间",
    //         value: 20.55,
    //       },
    //     ],
    //     image:
    //       "data:image/jpeg;base64,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",
    //   };
    //   let maskImage = new Image();
    //   maskImage.src = data.image;
    //   maskImage.onload = function () {
    //     myChart.setOption({
    //       series: [
    //         {
    //           type: "wordCloud",
    //           left: "center",
    //           top: "center",
    //           // width: "200%",
    //           // height:"120%",
    //           width: 1000,
    //           height:700,
    //           right: null,
    //           bottom: null,
    //           sizeRange: [12, 14],
    //           rotationRange: [0, 0],
    //           gridSize: 7,
    //           drawOutOfBound: false,
    //           maskImage: maskImage,
    //           textStyle: {
    //             fontFamily: "sans-serif",
    //             color: function () {
    //               let colorList = [
    //                 "rgb(12,57,176)",
    //                 "rgb(16,83,190)",
    //                 "rgb(18,102,201)",
    //                 "rgb(21,122,214)",
    //                 "rgb(25,140,220)",
    //                 "rgb(29,161,223)",
    //                 "rgb(32,180,226)",
    //                 "rgb(37,205,231)",
    //               ];
    //               let index = Math.floor(Math.random() * colorList.length);
    //               return colorList[index];
    //             },
    //           },
    //           data: data.value,
    //         },
    //       ],
    //     });
    //   };
    // },
    getInit3() {
      var myChart = new Js2WordCloud(document.getElementById("echart3"));
      // var wc = new Js2WordCloud(document.getElementById("echart3"));
      var colors = [
        "#FFC760",
        "#FB6993",
        "#4880FF",
        "#24CCB8",
        "#6FE621",
        "#173F89",
      ];
      var colorIndex = Math.random() * (colors.length - 1) + 0;
      var wordFreqData = [
        ["建筑", 36341],
        ["建材", 36341],
        ["工程", 36341],
        ["生物工程", 36075],
        ["制药", 36075],
        ["房地产", 35683],
        ["快速消费品", 35201],
        ["重工", 33120],
        ["设备", 33120],
        ["机械", 33120],
        ["院校", 29208],
        ["教育", 29208],
        ["培训", 29208],
        ["电子商务", 28047],
        ["互联网", 28047],
        ["计算机软件", 27370],
        ["集成电路", 27066],
        ["电子技术", 27066],
        ["半导体", 27066],
        ["汽车", 18948],
        ["专业服务", 16932],
        ["器械", 15413],
        ["医疗设备", 15413],
        ["进出口", 15017],
        ["贸易", 15017],
        ["运输", 13830],
        ["物流", 13830],
        ["交通", 13830],
        ["零售", 11493],
        ["批发", 11493],
        ["矿产", 10738],
        ["石油", 10738],
        ["地质", 10738],
        ["化工", 10738],
        ["工业自动化", 10381],
        ["仪器仪表", 10381],
        ["金融", 10273],
        ["证券", 10273],
        ["投资", 10273],
        ["物业管理", 9991],
        ["商业中心", 9991],
        ["纺织", 9974],
        ["皮革", 9974],
        ["服装", 9974],
        ["多元化业务集团公司", 9458],
        ["通信", 9382],
        ["新能源", 9193],
        ["原材料和加工", 8634],
        ["礼品", 8367],
        ["玩具", 8367],
        ["家电", 8367],
        ["家具", 8367],
        ["环保", 8124],
        ["护理", 7468],
        ["卫生", 7468],
        ["医疗", 7468],
        ["牧", 6917],
        ["渔", 6917],
        ["林", 6917],
        ["农", 6917],
        ["网络设备", 6439],
        ["电信", 6439],
        ["电气", 5588],
        ["电力", 5588],
        ["水利", 5588],
        ["艺术", 5465],
        ["文化传播", 5465],
        ["影视", 5465],
        ["媒体", 5465],
        ["装潢", 5094],
        ["家居", 5094],
        ["室内设计", 5094],
        ["餐饮业", 4668],
        ["银行", 2354],
        ["计算机硬件", 1888],
        ["珠宝", 1870],
        ["收藏品", 1870],
        ["工艺品", 1870],
        ["奢侈品", 1870],
        ["娱乐", 1777],
        ["体育", 1777],
        ["休闲", 1777],
        ["广告", 1745],
        ["生活服务", 1621],
        ["美容", 1436],
        ["保健", 1436],
        ["政府", 1418],
        ["公共事业", 1418],
        ["科研", 1403],
        ["学术", 1403],
        ["中介服务", 1279],
        ["外包服务", 1251],
        ["办公用品及设备", 1208],
        ["审计", 1075],
        ["会计", 1075],
        ["航空", 965],
        ["航天", 965],
        ["法律", 949],
        ["文字媒体", 807],
        ["出版", 807],
        ["市场推广", 761],
        ["公关", 761],
        ["会展", 761],
        ["网络游戏", 639],
        ["采掘业", 607],
        ["冶炼", 607],
        ["租赁服务", 449],
        ["非营利组织", 289],
        ["拍卖", 179],
        ["担保", 179],
        ["典当", 179],
        ["信托", 179],
      ];
      var option = {
        //https://ecomfe.github.io/echarts-wordcloud/example/logo.png
        //imageShape:'https://ecomfe.github.io/echarts-wordcloud/example/logo.png',
        tooltip: {
          show: true,
        },
        // imageShape: require('../assets/imgs/椭圆形@1x.jpg'),
        list: wordFreqData,
        gridSize: 6,
        fontSizeFactor: 0.1,
        maxFontSize: 12, //最大字号
        minFontSize: 16, //最小字号
        color() {
          //自定义颜色
          if (colorIndex > 6) {
            console.log(colorIndex);

            colorIndex = -1;
          }
          colorIndex += 1;
          return colors[colorIndex];
        },
        rotateRatio: 0, // 字体倾斜(旋转)概率，1代表总是倾斜(旋转)
        shape: "circle",
        ellipticity: 1,
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 16px;
  font-family: 思源黑体 Normal;
  font-weight: bold;
  color: #333333;
  margin-left: 5px;
}

.title span {
  display: block;
  font-size: 12px;
  font-family: 思源黑体 Normal;
  color: #999999;
  line-height: 19px;
  font-weight: normal;
  float: right;
  cursor: pointer;
}

.top_ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  li {
    width: calc((100% - 54px) / 4);
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    div {
      img {
        width: 24px;
        height: 24px;
        margin-left: 0;
        margin-right: 6px;
      }
      span {
        font-size: 14px;
        font-family: 思源黑体 Normal;
        color: #666666;
      }
      h3 {
        font-size: 24px;
        font-family: "DIN 1451 Mittelschrift";
        color: #202020;
        margin-top: 10px;
      }
    }
    img {
      width: 100px;
      height: 60px;
      margin-left: 7px;
    }
  }
}
.center {
  height: 416px;
  display: flex;
  justify-content: space-between;
  .echarts {
    width: 720px;
    padding: 15px;
    background: #ffffff;

    .echarts-main {
      width: 720px;
      height: 406px;
      margin-top: -35px;
      margin-left: -14px;
    }
  }
  .data-list {
    // width: 267px;
    width: calc((100% - 40px) / 3);
    // width: calc(100% - 746px);
    padding: 20px;
    background: #ffffff;
    ul {
      width: 100%;
    }
    ul li {
      font-size: 14px;
      font-family: 思源黑体 Normal;
      color: #333333;
      display: flex;
      margin-top: 14px;
      cursor: pointer;
    }

    ul li img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    ul li span {
      display: block;
      min-width: 20px;
      text-align: center;
      margin-right: 10px;
    }

    ul li p {
      width: calc(100% - 28px);
      margin-bottom: 0;
      word-wrap: normal;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
    }
  }
}

.bottom {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  li {
    width: calc((100% - 40px) / 3);
    height: 260px;
    padding: 15px 15px 0px 15px;
    background: #ffffff;

    .echart3 {
      width: 100%;
      height: 200px;
      margin-top: 10px;
      margin-left: -5px;
      // transform: scale(0.5);
    }

    div {
      width: 100%;
      height: 230px;
    }
  }
}
</style>